module.exports = __webpack_public_path__ + "main/assets/public/share-icons/facebook.90a759666a5c1e9a.svg";